import { render, staticRenderFns } from "./rightImg.vue?vue&type=template&id=34c53d53&scoped=true"
import script from "./rightImg.vue?vue&type=script&lang=js"
export * from "./rightImg.vue?vue&type=script&lang=js"
import style0 from "./rightImg.vue?vue&type=style&index=0&id=34c53d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c53d53",
  null
  
)

export default component.exports